import styled from "styled-components";

const Text = styled.span`
  position: absolute;
  margin-top: 8px;
  font-size: 10px;
`;

export default Text;
